import redirectToRoute from './redirectToRoute';

const redirectJobSlug = (
  job,
  slug,
  id,
  prefix,
  route,
  response,
  companySlug,
) => {
  if (job && slug !== job.slug) {
    return redirectToRoute(route, {
      id,
      slug: job.slug,
      ...companySlug ? { companySlug } : {},
      ...(prefix === 'fr' ? { prefix } : {}),
    }, response);
  }
  return {};
};

export default redirectJobSlug;
